<template>
  <div class="sf-level sf-level-between">
    <div
      v-for="{ options, name, updateFunction, errors } in xAxisOptions"
      :key="name"
    >
      <div class="sf-uppercase sf-below-1">
        {{ I18n.t(`js.report_graph.edit.x_axis_options.${decamelize(name)}`) }}
      </div>

      <div
        v-show="errors && !optionsSelected[name]"
        class="sf-alert sf-alert-danger sf-pad-1 sf-level-vertical sf-below-2"
      >
        <div class="sf-level-item">
          {{
            I18n.t(
              `js.report_graph.edit.x_axis_options.${decamelize(name)}_error`
            )
          }}
        </div>
      </div>

      <div class="sf-btn-bar sf-btn-bar-primary-subtle">
        <button
          v-for="option in options"
          :key="option"
          v-tooltip="disabledOptions[option]"
          class="sf-btn sf-btn-bar-item"
          :class="{ 'sf-btn-active': optionsSelected[name] === option }"
          :style="disabledOptions[option] && 'opacity: .5'"
          :for="option"
          @click="updateFunction(option)"
        >
          {{ I18n.t(`js.report_graph.edit.x_axis_options.${option}`) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { decamelize } from 'humps'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState(['readOnly', 'graph', 'graphPeriods']),
    ...mapGetters(['graphErrors']),

    optionsSelected() {
      return {
        frequency: this.graphPeriods.frequency,
        priorYears: this.graphPeriods.priorYears,
        yearType: this.graph.yearType,
      }
    },
    disabledOptions() {
      if (this.graphPeriods.ledgersPerYear < 4) {
        return {
          monthly: I18n.t(
            `js.report_graph.edit.x_axis_options.disabled_quarterly`
          ),
          quarterly: I18n.t(
            `js.report_graph.edit.x_axis_options.disabled_quarterly`
          ),
        }
      } else if (this.graphPeriods.ledgersPerYear < 12) {
        return {
          monthly: I18n.t(
            `js.report_graph.edit.x_axis_options.disabled_monthly`
          ),
        }
      } else {
        return {}
      }
    },
    xAxisOptions() {
      const options = [
        {
          name: 'frequency',
          options: ['monthly', 'quarterly', 'yearly'],
          updateFunction: this.updateFrequency,
          errors: this.graphErrors['reportGraphPeriods.periods'],
        },
        {
          name: 'yearType',
          options: ['booking_year', 'calendar_year'],
          updateFunction: this.updateYearType,
        },
      ]

      if (this.optionsSelected.frequency === 'yearly') {
        options.splice(1, 0, {
          name: 'priorYears',
          options: ['end_of_bookyear', 'current_month'],
          updateFunction: this.updatePriorYears,
          errors: this.graphErrors['reportGraphPeriods.periods'],
        })
      }

      return options
    },
  },
  methods: {
    ...mapActions(['setFrequency', 'setPriorYears', 'setYearType']),
    decamelize,
    updateFrequency(value) {
      if (this.readOnly || this.disabledOptions[value]) {
        return
      }
      this.setFrequency({ frequency: value })
    },
    updatePriorYears(value) {
      if (this.readOnly) {
        return
      }
      this.setPriorYears({ priorYears: value })
    },
    updateYearType(value) {
      if (this.readOnly) {
        return
      }
      this.setYearType({ yearType: value })
    },
  },
}
</script>

<style>
.radio-button {
  position: fixed;
  opacity: 0;
  pointer-events: none;
}

.ignore-css {
  all: unset;
}
</style>
